module.exports = __webpack_public_path__ + "static/media/symbol-prize.d8aa72d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-prize.svg
// module id = ./src/assets/images/symbol-prize.svg
// module chunks = 0